__turbopack_context__.v({
  "colSpan12": "Landscape-module__b6fy7G__colSpan12",
  "colSpan4": "Landscape-module__b6fy7G__colSpan4",
  "colSpan5": "Landscape-module__b6fy7G__colSpan5",
  "colSpan6": "Landscape-module__b6fy7G__colSpan6",
  "colSpan7": "Landscape-module__b6fy7G__colSpan7",
  "colSpan8": "Landscape-module__b6fy7G__colSpan8",
  "collapsedFormContainer": "Landscape-module__b6fy7G__collapsedFormContainer",
  "columnChangeStarRating": "Landscape-module__b6fy7G__columnChangeStarRating",
  "columnLandscape": "Landscape-module__b6fy7G__columnLandscape",
  "csLink": "Landscape-module__b6fy7G__csLink",
  "feedbackBox": "Landscape-module__b6fy7G__feedbackBox",
  "feedbackButton": "Landscape-module__b6fy7G__feedbackButton",
  "feedbackTextContainer": "Landscape-module__b6fy7G__feedbackTextContainer",
  "flexCenter": "Landscape-module__b6fy7G__flexCenter",
  "landscapeContainer": "Landscape-module__b6fy7G__landscapeContainer",
  "starRatingContainer": "Landscape-module__b6fy7G__starRatingContainer",
  "textAlignLeft": "Landscape-module__b6fy7G__textAlignLeft",
  "textAlignRight": "Landscape-module__b6fy7G__textAlignRight",
});
